import { createFileRoute } from "@tanstack/react-router";
import { SpacesView } from "@/modules/chat/components/SpacesView";

/**
 * Каталог всех пространств — `/spaces`. Открывается из сайдбара
 * («Показать все пространства»). Раньше жил в табе «Пространства»
 * у ControlPanel; перенесён в обычный раздел `_app` для консистентности
 * с историей, агентами, автоматизациями и т. п.
 */
export const Route = createFileRoute("/_app/spaces/")({
  component: SpacesRoute,
  // Поддерживаем `?new=1` как сигнал «открой диалог создания» — кнопка
  // в сайдбаре навигирует с этим параметром, чтобы попасть на каталог
  // и сразу же показать модалку. SpacesView читает search и сбрасывает
  // параметр после открытия, чтобы перезагрузка страницы не дёргала
  // диалог снова. Возвращаем строго optional-объект — иначе TanStack
  // делает `search` обязательным во всех navigate({ to: "/spaces" }).
  validateSearch: (search: Record<string, unknown>): { new?: true } => {
    const v = search.new;
    return v === "1" || v === true || v === "true" ? { new: true } : {};
  },
});

function SpacesRoute() {
  return <SpacesView />;
}
